import React from 'react';
import ModalLayout from '../layouts/ModalLayout';
import CancelSaveButton from '../misc/CancelSaveButton';

interface AreYouSureModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  saveClassName?: string;
  cancelClassName?: string;
}

export default function AreYouSureModal({
  open,
  setOpen,
  title,
  description,
  confirmLabel = 'Continue',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  saveClassName,
  cancelClassName,
}: AreYouSureModalProps): JSX.Element {
  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      className="relative transform overflow-hidden rounded-[12px] bg-secondary-50 px-6 py-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
      <div className="mb-4 flex flex-col gap-2">
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <div className="flex justify-end">
        <CancelSaveButton
          cancelText={cancelLabel}
          buttonText={confirmLabel}
          onCancel={() => {
            setOpen(false);
            onCancel?.();
          }}
          onSave={() => {
            setOpen(false);
            onConfirm();
          }}
          saveClassName={saveClassName}
          cancelClassName={cancelClassName}
        />
      </div>
    </ModalLayout>
  );
}
